<template>
  <footer class="hm-footer">
    <div class="container">
      <div class="container">
        <div class="row product">
          <!-- 已注释掉的产品列 -->
          <div class="col-md-4 col-6">
            <dl>
              <dt>
                <h3>关于我们</h3>
              </dt>
              <dd><router-link to="/about/intro">公司简介</router-link></dd>
              <dd><router-link to="/about/hxnews">新闻中心</router-link></dd>
              <dd><router-link to="/about/jobs">工作机会</router-link></dd>
            </dl>
          </div>
          <div class="col-md-4 col-6">
            <dl>
              <dt>
                <h3>联系我们</h3>
              </dt>
              <dd>
                <a href="tel:15392850129">
                  咨询电话：153 9285 0129
                  <!-- <div class="mt10">
                    <button type="button" class="btn btn-primary">禾苗24小时服务热线</button>
                  </div> -->
                </a>
              </dd>
              <dd>
                <a href="mailto:service2@hemiao100.com">
                  企业邮箱：service2@hemiao100.com
                </a>
              </dd>
            </dl>
          </div>
          <div class="col-md-4 col-sm-12 col-12 text-center">
            <div class="qrcode-wrapper">
              <img 
                src="../assets/images/ewm.png" 
                alt="公众号二维码" 
                class="qrcode"
              >
            </div>
            <div class="focus text-center">微信关注我们</div>
          </div>
        </div>
      </div>
      <div class="row info text-center">
        <div class="col-12">
          <div class="flex item-center flex-center">
            <p>©2015-2025</p>
            <div class="flex item-center flex-center" style="width: 405px; padding: 20px 0px;">
              <img 
                src="../assets/images/beian.png" 
                alt="备案图标"
              >
              <a 
                target="_blank" 
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42010302001621"
                style="text-decoration: none; height: 20px; line-height: 20px;"
              >
                <p style="float: left; height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: rgb(147, 147, 147);">
                  鄂公网安备 42010302001621号
                </p>
              </a>
              <a 
                target="_blank" 
                href="http://www.beian.miit.gov.cn"
                style="text-decoration: none; height: 20px; line-height: 20px;"
              >
                <p style="float: left; height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: rgb(147, 147, 147);">
                  鄂ICP备15014881号-1
                </p>
              </a>
            </div>
          </div>
        </div>
        <div class="col-12">
          <p>公司地址：湖北省武汉市江汉区淮海路中央商务区泛海国际SOHO城8栋8层</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.hm-footer {
  background-color: #2c3e50;
  color: #fff;
  padding: 3rem 0 2rem;
  margin-top: 2rem;
}

h3 {
  color: #fff;
  font-size: 18px;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

dd {
  margin-bottom: 0.8rem;
}

a {
  color: #bdc3c7;
  transition: color 0.3s ease;
}

a:hover {
  color: #fff;
  text-decoration: none;
}

.qrcode-wrapper {
  text-align: center;
  margin-bottom: 1rem;
}

.qrcode {
  width: 120px;
  height: 120px;
  border: 2px solid #fff;
  border-radius: 6px;
  transition: transform 0.3s ease;
}

.qrcode:hover {
  transform: scale(1.05);
}

.focus {
  color: #bdc3c7;
  font-size: 14px;
}

.info {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.info p {
  color: #95a5a6;
  margin-bottom: 0.5rem;
  font-size: 14px;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  font-size: 14px;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

/* 响应式布局调整 */
@media (max-width: 767px) {
  .hm-footer {
    padding: 2rem 0 1rem;
  }
  
  .product .col-md-4 {
    margin-bottom: 2rem;
    text-align: center;
  }
  
  .qrcode {
    width: 100px;
    height: 100px;
    margin: 0 auto;
  }
  
  .info {
    margin-top: 1rem;
    padding-top: 1rem;
  }
  
  .info p {
    font-size: 12px;
  }
  
  dl {
    display: inline-block;
    text-align: left;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .qrcode {
    width: 100px;
    height: 100px;
  }
}
</style>